import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-catalog-pageheader',
  templateUrl: './pageheader.component.html',
  styles: ['h1 {font-weight: 400}'],
})
export class PageheaderComponent {
  @Input() hxid = '';
  @Input() title = '';
  @Input() name = '';

  toBack(): void {
    window.history.back();
  }
}
